import './styles.sass';

import React from 'react';
import { Link } from 'react-router-dom';

import NumberHelper from 'util/number_helper';
import * as QueryParams from 'components/Explorer/models/query_params';
import useExplorerData, { Loading } from 'hooks/useExplorerData';
import useQueryParams from 'hooks/useQueryParams';

const linkForResearcher = (params, researcher) => {
  const filters = { ...(params.filters || {}), 'researcher_id[]': [researcher.id] };
  return QueryParams.locationFor(QueryParams.withFilters(params, filters), '/mentions');
};

const researcherMetaDataText = (researcher) => {
  const mentionText = researcher.total_mentions === 1 ? 'mention ' : 'total mentions ';
  const researchOutputText = researcher.total_research_outputs === 1 ? 'research output' : 'research outputs';

  return (
    <p className="Highlights-TopResearchers-metadata" data-testid={`researcher-${researcher.id}`}>
      <strong>{NumberHelper.formatStatistic(researcher.total_mentions)}</strong> {mentionText}
      from <strong>{NumberHelper.formatStatistic(researcher.total_research_outputs)}</strong> {researchOutputText}
    </p>
  );
};

const TopResearchers = () => {
  const params = useQueryParams();
  const { data, loading } = useExplorerData('highlights/top_researchers', params, { reloadOn: ['filters'] });

  return (
    <div className="Highlights-TopResearchers Highlights-block">
      <h2 className="Highlights-title">Top researchers</h2>

      <div className="Highlights-content-wrapper">
        {(loading === Loading.NOT_STARTED || loading === Loading.IN_PROGRESS) && (
          <div key="loadingMessage" className="Highlights-loading-message" />
        )}
        {loading === Loading.ERROR && (
          <div className="Highlights-error-message">{I18n.t('Explorer.loading_error')}</div>
        )}
        {loading === Loading.EMPTY_RESPONSE && (
          <div className="Highlights-content-empty-message">There are no researchers matching your search.</div>
        )}
        {loading === Loading.SUCCESS && (
          <div key="content" className="Highlights-content">
            {data.map((researcher) => (
              <div key={researcher.id} className="Highlights-TopResearchers-container">
                <div className="Highlights-TopResearchers-content">
                  <h3 className="Highlights-TopResearchers-title">
                    <Link to={linkForResearcher(params, researcher)}>{researcher.full_name}</Link>
                  </h3>
                  {researcher.affiliation && (
                    <p className="Highlights-TopResearchers-affiliation">{researcher.affiliation}</p>
                  )}
                  {researcherMetaDataText(researcher)}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default TopResearchers;
